/**
 * @generated SignedSource<<c209e2c17f0a0fa2be03c667fce306e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarPromotion_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarPromotionForm_item">;
  readonly " $fragmentType": "CheckoutSidebarPromotion_item";
};
export type CheckoutSidebarPromotion_item$key = {
  readonly " $data"?: CheckoutSidebarPromotion_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarPromotion_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarPromotion_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotionForm_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e90636b9f867a342b62dbe732e5ca4f2";

export default node;
